import { LogOut } from 'lucide-react';
import { ProfileAvatar } from '~/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '~/components/ui/dropdown-menu';
import useTranslation from '~/i18n/i18n';
import { useLogout } from '~/lib/hooks/use-logout';
import { useApi } from '~/lib/providers/api-provider';
import { useUser } from '~/lib/providers/user-provider';
import { Button } from '../ui/button';

interface AvatarProps {
  className?: string;
  mobile?: boolean;
}

export const Avatar = ({ className, mobile = false }: AvatarProps) => {
  const { t } = useTranslation();
  const { user } = useUser();
  const { api } = useApi();
  const { data: profile } = api.useGetProfile();
  const { logout, isLoading } = useLogout();

  if (!user) return null;

  if (mobile) {
    return (
      <div className="flex w-full flex-row items-center gap-4">
        <ProfileAvatar profile={profile} size="sm" />
        <div className="flex grow flex-col items-start justify-start gap-1 text-sm text-muted-foreground">
          {user.email}
        </div>
        <Button
          size="icon"
          variant="ghost"
          icon={LogOut}
          isLoading={isLoading}
          disabled={isLoading}
          onClick={() => logout()}
        />
      </div>
    );
  }

  return (
    <div className={className}>
      <DropdownMenu>
        <DropdownMenuTrigger className="rounded-full">
          <ProfileAvatar profile={profile} size="sm" />
        </DropdownMenuTrigger>
        <DropdownMenuContent sideOffset={20} side="bottom" align="end">
          <DropdownMenuLabel>
            <div className="flex flex-col gap-y-2">
              <p>{t('homePage.myAccount')}</p>
              <div className="text-xs font-light text-gray-400">
                {user.email}
              </div>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => logout()} disabled={isLoading}>
            {t('homePage.logout')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
